import { render, staticRenderFns } from "./ChapterQuestionsEditor.vue?vue&type=template&id=f96a65aa&"
import script from "./ChapterQuestionsEditor.vue?vue&type=script&lang=js&"
export * from "./ChapterQuestionsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports